import React from 'react';
import "@fontsource/nunito"
import "@fontsource/nunito-sans"
import "@fontsource/festive"

import './src/styles/global.css';
import './src/styles/normalize.css';
import { SessionProvider } from './src/contexts/session-provider';
import { camelize } from './src/components/utils';

export const wrapRootElement = ({ element, props }) => {
    return <SessionProvider {...props}>
        {element}
    </SessionProvider>
};

//
// See https://developers.google.com/analytics/devguides/collection/ga4/views?client_type=gtm#disable_pageview_measurement
// Also notes in consent-banner.
//
export const onRouteUpdate = ({ location }) => {
    if (window.consent?.granted) {
        const comps = location.pathname.split('/');
        console.log(`GATSBY-BROWSER +++++++++++ page_view [t: ${camelize(comps[comps.length - 1], true, false)}, l: ${location.href}, p: ${location.pathname}], EN: ${JSON.stringify(window.consent)}, DL: ${JSON.stringify(window.dataLayer)}`);
        window.gtag('event', 'page_view', {
            page_title: camelize(comps[comps.length - 1], true, false),
            page_location: location.href,
            page_path: location.pathname,
            ...(comps[1] === 'shop') && { page_filter:  window.shopFilter } // see layout.js
        });
    } else {
        const comps = location.pathname.split('/');
        console.log(`GATSBY-BROWSER ------------ deny page_view [t: ${camelize(comps[comps.length - 1], true, false)}, l: ${location.href}, p: ${location.pathname}], EN: ${JSON.stringify(window.consent)}, DL: ${JSON.stringify(window.dataLayer)}`);
    }
}

//
// Added this to fix strange 'minify' error from React
// on gatsby serve --port 8000.
//
/* export const replaceHydrateFunction = () => {
    return (element, container) => {
      const root = ReactDOM.createRoot(container)
      root.render(element)
    }
} */